import React, { useContext } from "react";
import { Link } from "react-router-dom";
import ContextComponent from "../Context";
import "../Containers/helpContainer.css";

const highlightText = (html, searchTerm) => {
  if (!searchTerm) return { __html: html };
  const regex = new RegExp(`(${searchTerm})`, "gi");
  const highlightedHtml = html.replace(
    regex,
    '<mark class="search-mark">$1</mark>',
  );
  return { __html: highlightedHtml };
};

const stripHtml = html => {
  if (!html) return "";
  let plainText = html.replace(/&nbsp;/g, " ").replace(/&zwnj;/g, "‌");
  plainText = plainText.replace(/<[^>]+>/g, "");
  return plainText;
};

const getSnippet = (text, searchTerm, wordsBefore = 9, wordsAfter = 9) => {
  if (!text || !searchTerm) return "";
  const plainText = stripHtml(text);
  const words = plainText.split(/\s+/);
  const searchWords = searchTerm.trim().split(/\s+/);
  let matchIndex = -1;

  for (let i = 0; i < words.length; i++) {
    if (words[i].toLowerCase().includes(searchWords[0].toLowerCase())) {
      matchIndex = i;
      break;
    }
  }

  if (matchIndex === -1) return "";
  const start = Math.max(0, matchIndex - wordsBefore);
  const end = Math.min(words.length, matchIndex + wordsAfter + 1);
  const snippet = words.slice(start, end).join(" ");
  return (
    (start > 0 ? "... " : "") + snippet + (end < words.length ? " ..." : "")
  );
};

const HelpItem = ({ data, linkToPost }) => {
  const context = useContext(ContextComponent);
  const searchTerm = context.query_parameters["search_term"];
  const processedBody = stripHtml(data.body);

  return (
    <Link className="help-link" to={linkToPost}>
      <div className="text-right help-item">
        <span dangerouslySetInnerHTML={highlightText(data.title, searchTerm)} />
        {searchTerm && (
          <div className="search-snippet" style={{ fontSize: "15px" }}>
            <span
              dangerouslySetInnerHTML={highlightText(
                getSnippet(processedBody, searchTerm),
                searchTerm,
              )}
            />
          </div>
        )}
      </div>
    </Link>
  );
};

export default HelpItem;
